const childrenLoaded = require('@alexspirgel/children-loaded');

class Video extends HTMLElement {

	static dynamicallyLoadVideoScript(type) {
		if (typeof this.videoScriptMap[type] === 'string') {
			return this.dynamicallyLoadScript(this.videoScriptMap[type]);
		}
		else {
			throw new Error(`No value found in videoScriptMap for '${type}'`);
		}
	}

	static dynamicallyLoadScript(source) {
		const existingScriptElement = document.querySelector(`script[src="${source}"]`);
		if (!existingScriptElement) {
			const scriptElement = document.createElement('script');
			scriptElement.src = source;
			const firstScriptElement = document.getElementsByTagName('script')[0];
			const promise = new Promise((resolve) => {
				scriptElement.onload = () => {
					resolve(true);
				};
			});
			firstScriptElement.parentNode.insertBefore(scriptElement, firstScriptElement);
			return promise;
		}
	}

	static get videoScriptMap() {
		const videoScriptsDirectory = localized_data.block_directory + '/scripts/video-scripts';
		return {
			youtube: videoScriptsDirectory + '/youtube-iframe-api-ready.js',
			vimeo: videoScriptsDirectory + '/vimeo-player-sdk-ready.js'
		};
	}

	static get accordionItemElements() {
		return document.querySelectorAll('.block-accordion__item');
	}

	static get accordionItemStateAttributeName() {
		return 'data-ace-item-state';
	}

	constructor() {
		super();
	}

	async connectedCallback() {
		await childrenLoaded(this);
		this.initialize();
	}

	initialize() {

		if (this.initialized) {
			return;
		}

		this.watchForParentAccordionClose();

		if (this.coverImageEnabled) {
			if (this.coverImageButtonElement) {
				this.coverImageButtonElement.addEventListener('click', () => {
					if (this.videoType === 'youtube'
					|| this.videoType === 'vimeo') {
						this.addFrameSrcFromDataSrc();
					}
					else if (this.videoType === 'file') {
						this.addVideoSourceSrcFromDataSrc();
					}
					this.hideCoverImage();
				});
			}
		}

		this.initialized = true;

	}

	get coverImageEnabled() {
		return this.getAttribute('data-cover-image');
	}
	
	get videoType() {
		return this.getAttribute('data-video-type');
	}

	get coverImageButtonElement() {
		return this.querySelector('.home-page-hero__cover-image-button');
	}

	get videoElement() {
		return this.querySelector('.home-page-hero__video');
	}

	hideCoverImage() {
		if (this.coverImageButtonElement) {
			this.coverImageButtonElement.classList.add('hidden');
		}
	}

	addFrameSrcFromDataSrc() {
		if (this.videoElement) {
			this.videoElement.setAttribute('src', this.videoElement.getAttribute('data-src'));
		}
	}

	addVideoSourceSrcFromDataSrc() {
		if (this.videoElement) {
			const sourceElements = this.videoElement.querySelectorAll('source');
			for (const sourceElement of sourceElements) {
				sourceElement.setAttribute('src', sourceElement.getAttribute('data-src'));
			}
			this.videoElement.load();
			this.videoElement.play();
		}
	}

	watchForParentAccordionClose() {
		const parentAccordionItemElements = this.parentAccordionItemElements;
		if (parentAccordionItemElements.length > 0) {
			this.loadFrameAPIPromise = this.loadIframeAPI();
			for (const parentAccordionItemElement of this.parentAccordionItemElements) {
				const observer = new MutationObserver(this.parentAccordionItemAttributeChangeCallback);
				observer.observe(parentAccordionItemElement, {attributes: true});
			}
		}
	}

	get parentAccordionItemElements() {
		const parentAccordionItemElements = []
		for (const accordionItemElement of this.constructor.accordionItemElements) {
			if (accordionItemElement.contains(this)) {
				parentAccordionItemElements.push(accordionItemElement);
			}
		}
		return parentAccordionItemElements;
	}

	parentAccordionItemAttributeChangeCallback = (mutationList, observer) => {
		for (const mutation of mutationList) {
			if (mutation.type === 'attributes' && mutation.attributeName === this.constructor.accordionItemStateAttributeName) {
				const accordionItemStateAttribute = mutation.target.getAttribute(this.constructor.accordionItemStateAttributeName);
				if (accordionItemStateAttribute === 'closed') {
					this.pauseVideo();
				}
			}
		}
	}

	loadIframeAPI() {
		const videoType = this.videoType;
		if (videoType === 'youtube'
		|| videoType === 'vimeo') {
			return this.constructor.dynamicallyLoadVideoScript(videoType);
		}
		else {
			return true;
		}
	}

	pauseVideo = async () => {
		if (this.videoType === 'vimeo') {
			await this.loadFrameAPIPromise;
			this.pauseVimeoVideo();
		}
		else if (this.videoType === 'youtube') {
			await this.loadFrameAPIPromise;
			this.pauseYouTubeVideo();
		}
		else if (this.videoType === 'file') {
			this.videoElement.pause();
		}
	}

	pauseVimeoVideo = async () => {
		if (!this.vimeoPlayer) {
			await vimeoPlayerSDKReady();
			if (this.videoElement.getAttribute('src')) {
				this.vimeoPlayer = new Vimeo.Player(this.videoElement);
				this.pauseVimeoVideo();
			}
		}
		else {
			this.vimeoPlayer.pause();
		}
	}

	pauseYouTubeVideo = async () => {
		if (!this.youtubePlayer) {
			await youTubeIframeAPIReady();
			if (this.videoElement.getAttribute('src')) {
				this.youtubePlayer = new YT.Player(this.videoElement);
				this.youtubePlayer.addEventListener('onReady', this.pauseYouTubeVideo);
			}
		}
		else {
			this.youtubePlayer.pauseVideo();
		}
	}

}

customElements.define('home-page-hero', Video, {extends: 'section'});

document.addEventListener('DOMContentLoaded', function () {
  const enhancedHero = document.querySelector('.enhanced-homepage-hero');
  const firstTwoColumns = document.querySelector('.block-two-columns');

  if (enhancedHero && firstTwoColumns) {
    firstTwoColumns.style.display = 'none';
  }
});